import { letters } from "./alphabet";
import { LetterClue, match } from "./match";
import { GuessDictionary, AnswersDictionary } from "./dictionary";
import { answerwords as ANSWER_WORDS } from "./answerwords";
import { wotdwords as WOTD_WORDS, extra } from "./wotdwords";
import makeXorshiftPrng from "./random";
import "svelte/store";
export const EM = " ";
export const emojis = ["", "\u{2B1C}", "\u{1F7E7}", "\u{1F7E9}"]; // map LetterClue enum to emoji
export const wordlen = 5;
export const guesses = 6;
export const SLOVL_EPOCH = "2022-01-24";
const wotdEpoch = +new Date(SLOVL_EPOCH);
export var GameMode;
(function (GameMode) {
    GameMode[GameMode["Random"] = 0] = "Random";
    GameMode[GameMode["WOTD"] = 1] = "WOTD";
})(GameMode || (GameMode = {}));
export var GameStatus;
(function (GameStatus) {
    GameStatus[GameStatus["Init"] = 0] = "Init";
    GameStatus[GameStatus["Playing"] = 1] = "Playing";
    GameStatus[GameStatus["Won"] = 2] = "Won";
    GameStatus[GameStatus["Lost"] = 3] = "Lost";
})(GameStatus || (GameStatus = {}));
export var ErrorStatus;
(function (ErrorStatus) {
    ErrorStatus["NoError"] = "NoError";
    ErrorStatus["NotFilled"] = "NotFilled";
    ErrorStatus["NotInDictionary"] = "NotInDictionary";
    ErrorStatus["AlreadyPlayed"] = "AlreadyPlayed";
    ErrorStatus["TooMuchLetters"] = "TooMuchLetters";
})(ErrorStatus || (ErrorStatus = {}));
export class Slovl {
    constructor() {
        this._listenersAlreadySolved = [];
        this.currentMode = GameMode.Random;
        this.gameStatus = GameStatus.Init;
        this.listeners = [];
        this.letters = new Array(guesses).fill(null).map(() => new Array(wordlen).fill(" "));
        this.currentRow = 0;
        this.step = 0;
        this.wotdModeGenerator = makeXorshiftPrng(27);
        this.randomModeGenerator = makeXorshiftPrng(7);
        this.randomAnswersDictionary = new AnswersDictionary(ANSWER_WORDS, this.randomModeGenerator);
        this.wotdAnswersDictionary = new AnswersDictionary(WOTD_WORDS, this.wotdModeGenerator);
        this.guessDictionary = new GuessDictionary(ANSWER_WORDS.concat(WOTD_WORDS));
        this.keyboardClues = [];
        this.clues = [];
        this.errorStatus = ErrorStatus.NoError;
    }
    start() {
        let dictionary = this.currentMode === GameMode.WOTD ? this.wotdAnswersDictionary : this.randomAnswersDictionary;
        this.word = dictionary.advance();
        this.currentRow = 0;
        this.errorStatus = ErrorStatus.NoError;
        this.letters = new Array(guesses).fill(null).map(() => new Array(wordlen).fill(" "));
        this.keyboardClues = [];
        this.clues = [];
        this.checkStatus();
        //this.syncURLParams();
    }
    cmd_sync_url() {
        let search;
        let title;
        if (this.currentMode === GameMode.WOTD) {
            search = "day=" + this.currentDay;
            title = "Словль: Словль дня";
        }
        else {
            search = "random=" + this.query_hex();
            title = "Словль: Рандом";
        }
        if (typeof window !== "undefined" && window.history.replaceState) {
            let url = new URL(window.location.href);
            url.search = search;
            window.history.replaceState({}, title, url);
        }
    }
    reset() {
        if (this.currentMode !== GameMode.Random)
            this.currentMode = GameMode.Random;
        this.start();
    }
    randomWord() {
        return this.randomAnswersDictionary.advance();
    }
    // Relevant doc: Svelte/store docs
    subscribe(fn) {
        this.listeners.push(fn);
        fn(this);
        return () => {
            const idx = this.listeners.indexOf(fn);
            if (idx !== -1)
                this.listeners.splice(idx, 1);
        };
    }
    changed() {
        this.step += 1;
        this.listeners.forEach((fn) => fn(this));
    }
    firstEmpty() {
        let row = this.letters[this.currentRow];
        let idx = row.indexOf(EM);
        return idx === -1 ? row.length : idx;
    }
    revealClues(row) {
        this.clues[row] = match(this.letters[row], this.word);
        let letterClues = Object.fromEntries(letters.map((l, idx) => [l, this.keyboardClues[idx] || LetterClue.Unknown]));
        for (let i = 0; i < this.letters[row].length; i++) {
            let letter = this.letters[row][i];
            letterClues[letter] = Math.max(letterClues[letter], this.clues[row][i]);
        }
        this.keyboardClues = letters.map(c => letterClues[c]);
    }
    usedBefore() {
        const locked = this.letters.slice(0, this.currentRow);
        const row = this.letters[this.currentRow];
        return locked.some((prevRow) => prevRow.every((l, i) => l === row[i]));
    }
    existingWord() {
        let word = this.letters[this.currentRow].join("");
        return this.guessDictionary.has(word);
    }
    checkStatus() {
        if (this.isTargetWord(this.currentRow - 1)) {
            this.gameStatus = GameStatus.Won;
            if (this.currentMode === GameMode.WOTD) {
                this.recordWonWOTD();
            }
            return;
        }
        if (this.currentRow >= guesses) {
            this.gameStatus = GameStatus.Lost;
            if (this.currentMode === GameMode.WOTD) {
                this.recordLostWOTD();
            }
            return;
        }
        this.gameStatus = GameStatus.Playing;
    }
    prepStorage(day) {
        let prev = JSON.parse(localStorage.getItem("SLOVL_WOTD") || "{}");
        if (!prev[day]) {
            prev[day] = [];
        }
        return prev;
    }
    recordWonWOTD() {
        const prev = this.prepStorage(this.currentDay);
        prev[this.currentDay].push([1, +new Date(), this.clues.length, this.clues]);
        localStorage.setItem("SLOVL_WOTD", JSON.stringify(prev));
        if (this.currentDay === this.dateToDay(new Date())) {
            localStorage.setItem("SLOVL_LAST_WOTD_ON_LAUNCH", String(this.currentDay));
        }
    }
    recordLostWOTD() {
        let prev = this.prepStorage(this.currentDay);
        prev[this.currentDay].push([0, +new Date(), this.clues.length, this.clues]);
        localStorage.setItem("SLOVL_WOTD", JSON.stringify(prev));
    }
    isTargetWord(row) {
        if (row >= 0) {
            let attempt = this.letters[row].join("");
            return this.word === attempt;
        }
        else {
            return false;
        }
    }
    /// User operations
    query_isPlaying() {
        return this.gameStatus === GameStatus.Playing;
    }
    dayToDate(d) {
        let today = new Date();
        let date = new Date(+new Date(SLOVL_EPOCH) + (d - 1) * 86400 * 1000);
        return date;
    }
    cmd_playOldWOTD(d) {
        const date = this.dayToDate(d);
        let canPlay = +date < +new Date();
        if (canPlay) {
            this.initWOTD(date);
        }
        this.currentMode = GameMode.WOTD;
        this.start();
        this.changed();
    }
    onAlreadySolvedDay(fn) {
        this._listenersAlreadySolved.push(fn);
        return () => {
            let idx = this._listenersAlreadySolved.indexOf(fn);
            if (idx !== -1)
                this._listenersAlreadySolved.splice(idx, 1);
        };
    }
    _triggerAlreadySolvedDay({ day, currentDay, solvedToday }) {
        if (this._listenersAlreadySolved.length === 0) {
            console.error("No listeners");
        }
        this._listenersAlreadySolved.forEach((fn) => fn({
            day,
            currentDay,
            suggestRandom: day === currentDay,
        }));
    }
    query_solvedWotd(day) {
        const prev = JSON.parse(localStorage.getItem("SLOVL_WOTD") || "{}");
        let solves = prev[day] || [];
        return solves.some((s) => s[0] === 1);
    }
    cmd_firstStart() {
        let today_day = this.dateToDay(new Date());
        let searchParams = new URLSearchParams(typeof window !== "undefined" ? window.location.search : "");
        let specifiedDay = parseInt(searchParams.get("day") || "NaN", 10);
        let last_played_wotd_day = localStorage.getItem("SLOVL_LAST_WOTD_ON_LAUNCH");
        let playedTodayWotd = String(today_day) === String(last_played_wotd_day);
        let specifiedRandom = searchParams.has("random");
        if (!Number.isNaN(specifiedDay)) {
            let date = this.dayToDate(specifiedDay);
            let canPlay = +date < +new Date();
            if (canPlay) {
                if (this.query_solvedWotd(specifiedDay)) {
                    this._triggerAlreadySolvedDay({ day: specifiedDay, currentDay: today_day, solvedToday: this.query_solvedWotd(today_day) });
                }
                this.initWOTD(date);
            }
            else {
                console.error("Plz wait");
                this.initWOTD(new Date());
            }
        }
        else {
            let date = new Date();
            this.initWOTD(date);
        }
        this.initRandomFromURL(searchParams);
        this.currentMode = specifiedRandom ? GameMode.Random : ((!playedTodayWotd || specifiedDay) ? GameMode.WOTD : GameMode.Random);
        console.log({ mode: this.currentMode, specifiedRandom, playedTodayWotd, specifiedDay });
        this.start();
        this.changed();
    }
    initRandomFromURL(searchParams) {
        let random = searchParams.get("random");
        if (random) {
            const st = random.split("~").map((s) => parseInt(s, 16));
            if (st.length === 3 && !st.some(n => Number.isNaN(n))) {
                console.error("Restoring permutation", st);
                this.randomAnswersDictionary.restorePermutation(st);
                return;
            }
        }
        let seed = parseInt(searchParams.get("seed") || "0", 16) || Date.now();
        this.randomModeGenerator.seed(seed);
        this.randomAnswersDictionary.resetPermutation();
    }
    dateToDay(d) {
        const diff = +d - wotdEpoch;
        const diff_days = diff / (86400 * 1000);
        const whole_days = Math.floor(diff_days);
        return whole_days + 1;
    }
    initWOTD(d) {
        let day = this.dateToDay(d);
        this.wotdModeGenerator.seed(27);
        this.wotdAnswersDictionary.resetPermutation();
        this.currentDay = day;
        while (day-- > 1) {
            this.wotdAnswersDictionary.advance();
        }
    }
    cmd_push(letter) {
        if (letter === "ё")
            letter = "е";
        const idx = this.firstEmpty();
        this.errorStatus = ErrorStatus.NoError;
        if (idx < wordlen)
            this.letters[this.currentRow][idx] = letter;
        else
            this.errorStatus = ErrorStatus.TooMuchLetters;
        this.changed();
    }
    cmd_backspace() {
        let row = this.currentRow;
        let deleted = this.firstEmpty() - 1;
        if (deleted >= 0) {
            this.letters[row][deleted] = EM;
            this.errorStatus = ErrorStatus.NoError;
            this.changed();
        }
    }
    cmd_commit() {
        const row = this.currentRow;
        const isFilled = this.firstEmpty() === this.letters[row].length;
        if (!isFilled) {
            this.errorStatus = ErrorStatus.NotFilled;
            this.changed();
            return;
        }
        let realWord = this.existingWord();
        if (!realWord) {
            this.errorStatus = ErrorStatus.NotInDictionary;
            this.changed();
            return;
        }
        let used = this.usedBefore();
        if (used) {
            this.errorStatus = ErrorStatus.AlreadyPlayed;
            this.changed();
            return;
        }
        this.errorStatus = ErrorStatus.NoError;
        this.revealClues(this.currentRow);
        this.currentRow += 1;
        this.checkStatus();
        this.changed();
    }
    cmd_suggestWord(word) {
        this.guessDictionary.suggest(word);
    }
    query_getCounts() {
        return {
            original: this.guessDictionary.guessSet.size,
            local: 0,
            remote: 0, //guessDictionary.remoteSet.size,
        };
    }
    query_emojiText() {
        // IDEA: add * at the end of the words that were added to the dictionary
        let cl = this.clues;
        let howfast = `${cl.length}/${guesses}`;
        let ll = [
            this.currentMode === GameMode.WOTD ? `Словль #slovl_day${this.currentDay} ${howfast}\n` : `Словль (рандом) ${howfast}\n`,
        ];
        cl.forEach((c, i) => {
            ll.push(c.map(c => emojis[c]).join(""));
        });
        const link = this.currentMode === GameMode.WOTD ? `https://timmarinin.net/slovl/?day=${this.currentDay}` : `https://timmarinin.net/slovl/?random=${this.query_hex()}`;
        ll.push("\n" + link);
        return ll.join("\n");
    }
    query_hex() {
        let params = this.randomAnswersDictionary.generationParameters;
        let permIdx = this.randomAnswersDictionary.currentPermutationIdx;
        return params.concat(permIdx).map(n => n.toString(16)).join("~");
    }
    cmd_anotherRandom() {
        this.randomModeGenerator.seed(Date.now());
        this.randomAnswersDictionary.resetPermutation();
        this.cmd_reset();
    }
    cmd_reset() {
        this.currentMode = GameMode.Random;
        this.reset();
        this.changed();
    }
    query_currentWord() {
        return this.letters[this.currentRow].join("");
    }
    processEvent(evtDescription) {
        return "";
    }
    query_hasExtra() {
        let inWOTD = this.currentMode === GameMode.WOTD;
        let won = this.gameStatus === GameStatus.Won;
        let hasMessage = extra[this.word];
        return inWOTD && won && hasMessage;
    }
    query_extra() {
        if (this.currentMode === GameMode.Random)
            return false;
        let extraMessage = extra[this.word];
        if (extraMessage) {
            let evtIdx = extraMessage.indexOf(":event:");
            if (evtIdx !== -1) {
                return this.processEvent(extraMessage);
            }
            else {
                return extraMessage;
            }
        }
        return false;
    }
}
export const game = new Slovl();
if (typeof window !== "undefined") {
    window["slovl"] = game;
}
